import { createExportHandlers } from '@src/main/modules/messages/utils/createExportHandlers';
import { normalizeCommercialEvaluationReport } from '@src/main/modules/messages/utils/formatters';
import { BriefCommercialEvaluation } from '@src/main/modules/reports/shared/domain/evaluation.interface';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export const useCommercialEvaluationExport = (
  evaluations: BriefCommercialEvaluation[],
  fileName: string,
) => {
  const { t } = useTranslation();

  return useMemo(
    () => createExportHandlers(evaluations, normalizeCommercialEvaluationReport, fileName, t),
    [evaluations, fileName, t],
  );
};
